import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPlans, startCheckout } from '../lib/api';
import { fallbackPlans } from '../data/content';
import { PlanCard, SectionHeading, Notice } from '../components/Shared';
import { useAuth } from '../hooks/useAuth';

export default function Pricing() {
  const [plans, setPlans] = useState(fallbackPlans);
  const [terms, setTerms] = useState(false);
  const [busy, setBusy] = useState('');
  const [message, setMessage] = useState('');
  const { session } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getPlans().then(setPlans).catch(() => setPlans(fallbackPlans));
  }, []);

  const choose = async (plan) => {
    if (!plan.price_amount) {
      navigate('/organisations');
      return;
    }
    if (!session) {
      sessionStorage.setItem('selected_plan', plan.id);
      navigate('/login?mode=signup');
      return;
    }
    try {
      setBusy(plan.id);
      setMessage('');
      await startCheckout(plan.id, terms);
    } catch (error) {
      setMessage(error.message);
      setBusy('');
    }
  };

  return (
    <>
      <section className="page-hero">
        <span className="eyebrow">Simple pricing</span>
        <h1>Choose a plan for consistent growth</h1>
        <p>Secure recurring billing, clear renewal dates and the flexibility to cancel future renewal.</p>
      </section>
      <section className="section">
        <div className="grid three pricing-grid">{plans.map((plan) => <PlanCard key={plan.id} plan={plan} onChoose={choose} loading={busy === plan.id} />)}</div>
        <label className="terms-check"><input type="checkbox" checked={terms} onChange={(event) => setTerms(event.target.checked)} />I agree to the Terms and Conditions and Privacy Policy.</label>
        {message && <Notice type="error">{message}</Notice>}
        <div className="secure-note">
          <SectionHeading title="Secure payment through Stripe" text="Credit cards, debit cards, Apple Pay and Google Pay are available where supported. We never store payment card details." />
        </div>
      </section>
    </>
  );
}